/**
 * 根据数组内的某个key分组
 * @param array 数组本身
 * @param key
 * @returns {*}
 */
export const groupBy = function (array, key) {
    const grouped = array.reduce((acc, obj) => {
        const code = obj[key];
        if (!acc[code]) {
            acc[code] = [];
        }
        acc[code].push(obj);
        return acc;
    }, {});
    return grouped;
}

/**
 * 根据数组内的某个key去重
 * @param arr
 * @param key
 * @returns {*}
 */
export  const  uniqueFunc = function (arr, key){
    const res = new Map();
    return arr.filter((item) => !res.has(item[key]) && res.set(item[key], 1));
}

// 排序
export const compare = function(property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    }
}